export default __webpack_public_path__ + "static/media/menu-icon.7b095371.svg";